import React from 'react';
import Scroll from 'react-scroll';

var Link = Scroll.Link;

class Hero extends React.Component {
	render () {
		return (
			<section id="home" name="home" className="hero__section section">
			  <div className="container">
			    <div className="row">
			      <div className="sm-12 col u-mt++ u-pt++ fade--in-up">
			        <h1 className="hero__heading"><span>Web</span> Developer</h1>
			        <h2 className="hero__heading">Francis Langlois</h2>
			      </div>
			    </div>
			  </div>
			  <div className="u-bottom u-center u-mb++ u-pb++">
			    <button className="button heartbeat"><Link to="work" spy={true} smooth={'easeInQuad'} offset={-50} duration={650}>View Work</Link></button>
			  </div>
			</section>
		)
	}
}

export default Hero;



// WEBPACK FOOTER //
// ./src/components/Hero.js